<template>
    <select v-model="proxySelected" :disabled="disabled"
            :class="inputClasses">
        <slot></slot>
    </select>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ['update:selected'],

    props: {
        selected: {
            type: [Array, Boolean, Number, String, Object],
            default: false,
        },
        value: {
            default: null,
        },
        error : {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        inputClasses() {
            return this.error ? 'block w-full text-lg border-red-600 rounded-md focus:border-red-400 form-input'
                : 'block w-full text-lg border-dark rounded-md focus:border-black focus:outline-none focus:shadow-outline-white form-input';
        },
        proxySelected: {
            get() {
                return this.selected;
            },

            set(val) {
                this.$emit("update:selected", val);
            },
        },
    },
})
</script>
